export const NAME = 'conversation'

export const GET_WIDGET_DATA = `${NAME}/GET_WIDGET_DATA`
export const SAVE_RESTORE_ID = `${NAME}/SAVE_RESTORE_ID`
export const INIT_WIDGET = `${NAME}/INIT_WIDGET`

// temporary solution until Merchant Portal has proper language selection
// this only works as long as we only support countries with one language
export const LOCALES = {
  SE: 'sv_SE',
  DE: 'de_DE',
  NO: 'nb_NO',
  GB: 'en_GB',
  FI: 'fi_FI',
  US: 'en_US',
  NL: 'nl_NL',
  AT: 'de_AT',
  DK: 'da_DK',
  AU: 'en_AU',
  BE: 'nl_BE',
  ES: 'es_ES',
  IT: 'it_IT'
}
